<template>
  <div class="createPlayStep">
    <div class="backBox">
      <img
        class="pointer"
        @click="clickLocalStep()"
        src="@/assets/thdImg/pages/back.svg"
        alt=""
      />
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div class="formBox">
      <!-- 步骤条 -->
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="1">
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <!--  活动条件表单部分 -->
      <div class="secondstep">
        <el-form
          :model="ruleForm"
          :rules="rules"
          class="backgroundForm"
          ref="ruleForm"
          label-width="120px"
        >
          <el-form-item label="活动名称:" required>
            <el-input
              v-model="ruleForm.activityName"
              maxlength="50"
              show-word-limit
              placeholder="积分任务的展示名称"
              style="width: 400px"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动时间:" required>
            <div class="my_select_time">
              <el-date-picker
                v-model="activityTimeValue"
                type="datetimerange"
                class="rangeTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                ref="timeBox"
                @change="activityTimeChange"
                style="width: 400px; font-size: 12px"
                :picker-options="pickerOptionsValue"
                :default-time="defaultTime"
              >
              </el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                @click="activityTimeValue = []"
              ></i>
              <img
                src="@/assets/images/select_date.svg"
                alt=""
                class="date_icon2"
              />
            </div>
            <span class="lastTime" style="color: #666">
              活动持续 <span style="color: #2670fb">{{ timeDay }}</span> 天
              <span style="color: #2670fb">{{ timeOut }}</span> 小时
              <el-tooltip
                class="item"
                effect="light"
                content="活动有效期不可超过订购有效期"
                placement="bottom"
              >
                <el-button type="text" style="width: 35px">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </span>
          </el-form-item>
          <el-form-item label="活动对象:" required>
            <el-radio-group
              v-model="ruleForm.activityObject"
              :disabled="isStartEdit"
              @change="handleActivityObj"
              style="margin-right: 16px"
            >
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">指定身份</el-radio>
              <el-radio :label="2" disabled>指定人群</el-radio>
            </el-radio-group>
            <el-popover
              placement="right-start"
              trigger="hover"
              content="您不满足使用该功能的条件，请联系专属客服了解~"
            >
              <el-button slot="reference" disabled>{{
                peopleList.length == 0
                  ? "选择人群"
                  : `已选${peopleList.length}个`
              }}</el-button>
            </el-popover>
          </el-form-item>
          <el-form-item
            label="新老客户:"
            required
            v-if="ruleForm.activityObject == '1'"
          >
            <el-radio-group
              v-model="ruleForm.newOldCustomer"
              :disabled="isStartEdit"
            >
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">新客</el-radio>
              <el-radio :label="2">老客</el-radio>
            </el-radio-group>
            <el-tooltip effect="dark" placement="top-start">
              <div slot="content">
                1、历史订单中已完成订单的订单数为0则定义为新客<br />2、历史订单中已完成订单的订单数≥1则定义为新客
              </div>
              <div
                class="cursorPointer"
                style="
                  display: inline-block;
                  margin-left: 16px;
                  font-size: 12px;
                  color: #999;
                "
              >
                <span>新老客说明</span>
                <i class="el-icon-question"></i>
              </div>
            </el-tooltip>
          </el-form-item>
          <el-form-item
            label="参与对象:"
            prop="partner"
            v-if="ruleForm.activityObject == '1'"
          >
            <el-checkbox-group
              v-model="ruleForm.partner1"
              @change="checkListchange"
              :disabled="isStartEdit"
            >
              <el-checkbox label="-1" name="partner">全部</el-checkbox>
              <el-checkbox
                label="0"
                name="partner"
                :disabled="ruleForm.partner1 == -1"
                >非会员</el-checkbox
              >

              <el-checkbox
                v-for="(item, index) in levelList"
                :key="index"
                :label="index + 1 + ''"
                name="partner"
                :disabled="ruleForm.partner1 == -1"
                >{{ item }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <el-form-item
            label="入会时间:"
            v-if="ruleForm.activityObject == '1' && ruleForm.partner1 != 0"
          >
          <el-date-picker
            v-model="ruleForm.membershipTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            type="datetime"
            :disabled="isStartEdit"
            placeholder="选择日期时间">
          </el-date-picker>
          之后成为会员的用户可参与活动
          </el-form-item>
          <el-form-item label="背景设置:" prop="partner">
            <el-radio v-model="picType1" :label="0" :disabled="isStartEdit"
              >系统预设</el-radio
            >
            <el-radio v-model="picType1" :label="1" :disabled="isStartEdit"
              >自定义</el-radio
            >
            <div class="m-b-24" v-show="picType1 == 0">
              <img src="@/assets/thdImg/cover/积分兑换.png" class="avatar" />
            </div>
            <div v-show="picType1 == 1">
              <div class="imgUpload m-b-20">
                <el-upload
                  class="avatar-uploader"
                  action=""
                  multiple
                  :limit="1"
                  :disabled="isStartEdit"
                  :before-upload="beforeUpload1"
                  accept=".jpg,.png"
                >
                  <img v-if="imageUrl1" :src="imageUrl1" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <div style="color: #999999; margin-bottom: 10px">
                  <p class="my-mg-10">建议上传尺寸：750px*1820px</p>
                  <p class="my-mg-10">图片大小：2MB以内</p>
                  <p class="my-mg-10">格式：jpg、png</p>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="按钮设置:">
            <div class="buttonBox">
              <el-form-item label="按钮背景图:" labelWidth="100px">
                <div style="display: flex;align-items: center;">
                  <el-upload ref="buttonPicUrlRef" action="" :disabled="isStartEdit" :limit="1" :before-upload="(file) => picUrlHandleChange(file)">
                    <img v-if="ruleForm.buttonPicUrl" :src="ruleForm.buttonPicUrl" style="width: 200px;height: auto;">
                    <el-button v-else type="text" :disabled="nowType == 'look' ||
                      (nowType == 'edit' && activityData.status == 2)
                      ">自定义上传</el-button>
                  </el-upload>
                  <el-button :disabled="isStartEdit" style="margin-left: 10px;" @click="ruleForm.buttonPicUrl = ''" type="text">重置</el-button>
                  <span style="margin-left: 10px;color: #999999;">建议上传尺寸为：602*88px；</span>
                </div>
              </el-form-item>
              <el-form-item label="按钮文字色:" labelWidth="100px">
                <el-color-picker :disabled="isStartEdit" v-model="ruleForm.buttonRgb"></el-color-picker>
                <el-button :disabled="isStartEdit" style="margin-left: 10px;" @click="ruleForm.buttonRgb = '#ffffff'" type="text">重置</el-button>
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item label="兑换商品:" prop="setPrize">
            <el-button @click="addTask" :disabled="isStartEdit"
              >+添加商品</el-button
            >
          </el-form-item>
          <!-- 兑换商品显示 -->
          <el-form-item label="" prop="setPrize">
            <div class="wide" v-for="(item, index) in ruleDTOList" :key="index">
              <div class="rulebox_flex">
                <div>商品名称：{{ item.title }}</div>
                <div class="posi">
                  <el-button
                    style="width: 50px"
                    :disabled="isStartEdit"
                    @click="moveUP(ruleDTOList[index], index)"
                    >上移</el-button
                  >
                  <el-button
                    style="width: 50px"
                    :disabled="isStartEdit"
                    @click="moveDown(ruleDTOList[index], index)"
                    >下移</el-button
                  >
                  <el-button style="width: 50px" @click="edit(item, index)"
                    >编辑</el-button
                  >
                  <el-button
                    style="width: 50px"
                    :disabled="isStartEdit"
                    @click="deletePacket(index)"
                    >删除</el-button
                  >
                </div>
              </div>
              <div class="rulebox_flex">
                <div class="flex">
                  商品图片：
                  <div v-if="item.logo" :class="[item.prizeType==1 ? 'coupon_icon' : 'date_icon3']">
                    <img
                      :src="item.logo"
                      alt=""
                      class="logo-style"
                    />
                    <div class="logo-modal" v-if="(item.prizeType==3||item.prizeType==1)&&(nowType=='draft'||!activityData.status||activityData.status==1||activityData.status==2||nowType=='copy')">
                      <i class="el-icon-delete delete-icon" @click="handleDelete(item)"></i>
                    </div>
                  </div>
                  <el-upload
                    v-else
                    ref="uploadRef"
                    action=""
                    :limit="1"
                    list-type="picture-card"
                    :before-upload="(file) => handleChange(file, item)"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </div>
              </div>
              <div class="rulebox_flex">
                <div>商品价值：￥{{ item.price }}</div>
              </div>
              <div v-if="item.prizeType==1" class="flexc-cen-start">
                <div>优惠券信息：</div>
                <div class="coupon-box">
                  <div class="flex-box">
                    <div class="rulebox_flex">
                      <div class="label-width">优惠券名称：</div>
                      <div>{{ item.title }}</div>
                    </div>
                    <div class="rulebox_flex" v-if="item.remainPrizeQuantity">
                      <div class="label-width">发放量：</div>
                      <div class="num-style">{{ item.remainPrizeQuantity }}张</div>
                    </div>
                  </div>
                  <div class="flex-box">
                    <div class="rulebox_flex" v-if="item.startDate">
                      <div class="label-width">使用时间：</div>
                      <div>{{ item.startDate }}~{{ item.endDate }}</div>
                    </div>
                    <!-- <div class="rulebox_flex">
                      <div class="label-width">每人限领：</div>
                      <div>{{ item.exchangeLimit }}张</div>
                    </div> -->
                  </div>
                  <div class="flex-box" v-if="item.conditions">
                    <div class="rulebox_flex">
                      <div class="label-width">面额门槛：</div>
                      <div>满{{ item.conditions }}元减{{ item.price }}元</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="rulebox_flex">
                <div>
                  参与要求：{{
                    item.joinType == ""
                      ? "不限制"
                      : item.joinType == 1
                      ? "限会员"
                      : item.joinType == 2
                      ? "限粉丝"
                      : "限粉丝,限会员"
                  }}
                </div>
              </div>
              <div class="rulebox_flex">
                <div>所需积分：{{ item.consumePoint }} 积分</div>
              </div>
              <div class="rulebox_flex">
                <div>剩余库存：{{ item.totalAmount }} 份</div>
              </div>
              <div class="rulebox_flex">
                <div>兑换上限：{{ item.exchangeLimit }} 份</div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="活动规则:" required>
            <div
              style="
                width: 500px;
                backgroundcolor: rgba(250, 250, 250, 1);
                padding: 8px;
                position: relative;
              "
            >
              <el-input
                type="textarea"
                class="textarea"
                style="width: 484px"
                resize="none"
                v-model="ruleForm.ruleDescription"
                :maxlength="2000"
                :disabled="backgroundOpacity"
              ></el-input>
              <div class="prosi" style="color: #909399">
                （{{
                  ruleForm.ruleDescription.length
                    ? ruleForm.ruleDescription.length - 1
                    : 0
                }}/2000）
              </div>
              <div>
                <el-button
                  type="primary"
                  class="generate"
                  plain
                  @click="generateRule"
                  :disabled="backgroundOpacity"
                >
                  生成规则
                </el-button>
                <span class="desc">
                  <i
                    class="el-alert__icon el-icon-info"
                    style="color: #999"
                  ></i>
                  点击按钮自动生成规则，也可以自己编辑信息
                </span>
              </div>
            </div>
          </el-form-item>
          <div v-if="backgroundOpacity" class="backgroundOpacity"></div>
        </el-form>
      </div>
    </div>
    <div class="create_bottom">
      <el-button
        v-show="!itemId"
        class="createBtn create_bottom_returnBtn"
        size="medium"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</el-button
      >
      <template v-if="!backgroundOpacity">
        <el-button
          v-show="!itemId"
          v-if="isSave"
          class="createBtn create_bottom_keepBtn"
          type="primary"
          size="medium"
          @click="saveEdit"
          v-preventReClick
          >保存设置</el-button
        >
      </template>
      <el-button
        v-show="itemId"
        class="createBtn create_bottom_returnBtn"
        size="medium"
        @click="cancelEdit"
        >取消</el-button
      >
      <el-button
        v-show="itemId"
        class="createBtn create_bottom_keepBtn"
        type="primary"
        size="medium"
        >保存设置</el-button
      >
    </div>
    <selectGoodsMonitor
      v-if="selectGoodsState"
      @transferName="selectGoodsClose"
      :postForm="selectGoodsArr"
      :maxNum="20"
    >
    </selectGoodsMonitor>
    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 添加任务 -->
    <el-dialog
      :title="nameTitle"
      :visible.sync="dialogFormVisible"
      width="570px"
    >
      <div
        class="rulebox"
        style="
          background: #fff;
          margin-top: 0;
          padding: 0;
          width: 500px;
          min-height: 254px;
          margin-left: 12px;
        "
      >
        <div class="rulebox_flex">
          <span class="rulebox_flex_left">奖品来源：</span>
          <div>
            <el-button
              @click="centerVis"
              style="margin-left: -30px"
              :disabled="isStartEdit"
              >选择奖品</el-button
            >
          </div>
        </div>
        <!-- Note奖品显示 -->
        <div class="rulebox_flex">
          <!-- 选择奖品显示 -->
          <div class="theLag" v-if="goodItem.prizeType">
            <div class="theBox">
              <p
                style="
                  margin: 30px 0 25px 0;
                  width: 280px;
                  text-align: center;
                  padding-left: 25px;
                  text-overflow: -o-ellipsis-lastline;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 1;
                  line-clamp: 1;
                  -webkit-box-orient: vertical;
                "
              >
                {{ goodItem.title }}
              </p>
              <p class="pp">{{ goodItem.prizeType | prizeType }}</p>
            </div>
            <div class="backgrd"></div>
            <el-button
              v-if="!isStartEdit||isCopy"
              class="btnQx"
              type="primary"
              @click="deleteCoupon"
              :disabled="isStartEdit"
              >删除</el-button
            >
          </div>
        </div>
        <div class="rulebox_flex">
          <span class="rulebox_flex_left">参与要求：</span>
          <el-checkbox-group
            :disabled="isStartEdit"
            v-model="ruleForm.joinType"
            @change="handleDischange"
            style="margin-left: -30px"
          >
            <!-- <el-checkbox label="-1" name="partner" :disabled="disItem == 1">不限制</el-checkbox> -->
            <el-checkbox label="限会员" name="partner"></el-checkbox>
            <el-checkbox label="限粉丝" name="partner"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="rulebox_flex">
          <span class="rulebox_flex_left">消耗积分：</span>
          <div>
            <el-input
              :disabled="isStartEdit"
              v-model.number="goodItem.consumePoint"
              @input="goodItem.consumePoint = getNumberData($event, 1)"
              placeholder="请填入"
              style="width: 80px; margin-left: -30px"
            ></el-input
            >&nbsp;积分
          </div>
        </div>
        <div class="rulebox_flex">
          <span class="rulebox_flex_left">商品份数：</span>
          <div>
            <el-input
              v-model.number="goodItem.totalAmount"
              @blur="beAdd()"
              @input="goodItem.totalAmount = getNumberData($event, 0)"
              placeholder="请填入"
              style="width: 80px; margin-left: -30px"
            ></el-input
            >&nbsp;份
          </div>
        </div>
        <div class="rulebox_flex">
          <span class="rulebox_flex_left">兑换上限：</span>
          <div>
            <el-input
              :disabled="goodItem.prizeType == 10 || isStartEdit"
              v-model.number="goodItem.exchangeLimit"
              @input="goodItem.exchangeLimit = getNumberData($event, 0)"
              placeholder="请填入"
              style="width: 80px; margin-left: -30px"
            ></el-input
            >&nbsp;份
          </div>
        </div>
        <div class="rulebox_flex" style="justify-content: center">
          <div class="createAdd_qx pointer" @click="dialogFormVisible = false">
            取消
          </div>
          <div class="createAdd_save pointer" @click="handleSave">确定</div>
        </div>
      </div>
    </el-dialog>
    <!-- 选择奖品弹窗 -->
    <selectProduct
      :putPrize="putPrize"
      :hide="1"
      @close="colseDialog"
      v-if="showDialog"
      :tipShow="true"
      ref="selectProduct"
      @choose-shop="getTheData"
    >
    </selectProduct>
  </div>
</template>

<script>
import {
  pointExchangeSave,
  pointExchangeDetail,
} from "@/api/integralCenter/integralTask";
import { uploadImage } from "@/api/sellerImageController";
import selectProduct from "./select_product.vue";
import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import draggable from "vuedraggable";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
const cityOptions = [
  {
    value: 0,
    name: "限会员",
  },
  {
    value: 1,
    name: "限粉丝",
  },
];
export default {
  components: {
    selectProduct,
    selectGoodsMonitor,
    draggable,
  },
  created() {
    this.activityData = this.$route.query.activityData;
    this.localStepNum = this.activityData.id;
    console.log("this.$route.query------>", this.$route.query);
    console.log("this.localStepNum------>", this.localStepNum);
    if (this.$route.query.valueRow) {
      this.valueRow = this.$route.query.valueRow;
      this.backgroundOpacity =
        this.$route.query.backgroundOpacity == "true" ? true : false;
      this.isSave = this.$route.query.isSave == "true" ? true : false;
      this.isStartEdit = this.$route.query.isStartEdit == "true" ? true : false;
      this.isEdit = this.$route.query.isStartEdit ? true : false
      this.pointExchangeDetail();
    } else if (this.$route.query.copyParams) {
      // 复制
      this.isCopy = true;
      this.backgroundOpacity = false;
      this.isSave = true;
      this.valueRow = this.$route.query.copyParams.valueRow;
      this.isStartEdit = false;
      this.pointExchangeDetail();
    } else {
      this.activityTimeChange();
    }
    this.getLevel();
  },
  filters: {
    prizeType(num) {
      var result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "淘宝E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "淘宝PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      } else if (num == "10") {
        result = "专属商品";
      }
      return result;
    },
  },
  mounted() {
    this.handleDischange();
    window.vm = this;
  },
  data() {
    return {
      isShowSelectCrowd: false,
      peopleList: [],
      isStartEditTime: "",
      isStartEdit: false,
      disItem: 0,
      isCopy: false,
      eleNumber: 1,
      imgUrlOne: "",
      step: 0, //  0-入会前 1-入会后
      imageUrl1: "",
      imageUrl2: "",
      indexNum: "",
      //添加商品弹框
      nameTitle: "", //添加和编辑名称的改变
      cities: cityOptions,
      ruleDTOList: [],
      dialogFormVisible: false,
      element: "", //点击保存添加一行
      putPrize: {},
      goodItem: {
        consumePoint: "",
        title: "",
        exchangeLimit: "",
        logo: "",
        price: "",
        totalAmount: "",
        type: "",
        prizeId: "",
      },
      showDialog: false,
      picType1: 0, // 是否预设 0-系统预设 1-自定义
      valueRow: null,
      statusComment: false,
      localStepNum: 1,
      activityData: {
        id: 132,
      },
      activeValue: null,
      itemId: "",
      backgroundOpacity: false,
      isSave: true,
      defaultTime: [
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
      ],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() >
              new Date(this.$store.state.loginUserInfo.expiredIn).valueOf()
          );
        },
      },
      disableTime: false,

      //时间限制
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.activityStartTime) {
            return (
              time.getTime() <
              new Date(this.ruleForm.activityStartTime).getTime()
            );
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.ruleForm.activityEndTime) {
            return (
              time.getTime() > new Date(this.ruleForm.activityEndTime).getTime()
            );
          } else {
          }
        },
      },

      checked: false,
      joinBlackList: false,
      mainImagelist: [], //图片拖拽排序
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      selectGoodsArr: [],
      selectGoodsArr2: [],
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      tableData: [
        {
          peopleCount: "",
          prizeType: "",
          price: "",
          prizeCount: "",
          singleAmount: "",
        },
      ],
      levelList: [],
      ruleForm: {
        membershipTime:"",
        //设置规则表单
        activityName: "",
        partner: ["-1"],
        startTime: "",
        joinType: [],
        activityStartTime: "", //活动开始时间
        activityEndTime: "", //活动结束时间
        activityObject: 0,
        newOldCustomer: 0,
        partner1: ["-1"],
        ruleDescription: "", //生成规则
        
        buttonPicUrl: "",
        buttonRgb: "#ffffff",
      },
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "blur",
          },
        ],
        isLongTime: [
          { required: true, message: "请选择活动时间", trigger: "change" },
        ],
        ruleDescription: [
          { required: true, message: "请填写活动规则", trigger: "blur" },
        ],
        partner: [
          {
            type: "array",
            required: true,
            message: "至少选择一个",
            trigger: "change",
          },
        ],
        startTime: [{ required: true, message: "请选择开始时间" }],
      },
      isEdit: false,
    };
  },
  watch: {},
  methods: {
    handleDischange() {
      let isdisable = false;
      this.ruleForm.joinType.forEach((item) => {
        if (item == "-1") isdisable = true;
      });
      if (isdisable) this.disItem = 2;
      if (!isdisable && this.ruleForm.joinType.length > 0) this.disItem = 1;
      if (this.ruleForm.joinType == 0) this.disItem = 0;
    },

    pointExchangeDetail() {
      pointExchangeDetail(this.valueRow.id).then((res) => {
        this.activityTimeValue = [
          String(res.data.startTime),
          String(res.data.endTime),
        ];
        let datas, change1, change2, days, daysStart, daysEnd, date3;
        daysStart = res.data.startTime.substring(0, 10);
        daysEnd = res.data.endTime.substring(0, 10);
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        this.timeDay = days;
        //计算小时
        date3 =
          new Date(res.data.endTime).getTime() -
          new Date(res.data.startTime).getTime();
        let leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
        this.picType1 = res.data.picType;
        if (res.data.picType == 1) {
          this.imageUrl1 = String(res.data.picUrl);
        }
        this.ruleForm.activityName = res.data.activityName;
        this.ruleForm.membershipTime = res.data.membershipTime
        this.ruleForm.activityStartTime = String(res.data.startTime);
        this.ruleForm.activityEndTime = String(res.data.endTime);
        
        if(res.data.buttonPicUrl){
          this.ruleForm.buttonPicUrl = res.data.buttonPicUrl
        }
        if(res.data.buttonRgb){
          this.ruleForm.buttonRgb = res.data.buttonRgb
        }
        
        this.ruleForm.activityObject = res.data.hasOwnProperty("activityObject")
          ? res.data.activityObject
          : 0;
        this.ruleForm.newOldCustomer = res.data.hasOwnProperty("newOldCustomer")
          ? res.data.newOldCustomer
          : 0;
        this.peopleList =
          res.data.hasOwnProperty("seniorGroupId") &&
          res.data.seniorGroupId.length > 0
            ? res.data.seniorGroupId.split(",")
            : [];

        this.ruleForm.partner1 = res.data.allowLevel.split(",");

        this.ruleForm.ruleDescription = this.isCopy
          ? ""
          : String(res.data.ruleDescription); //生成规则
        this.ruleDTOList = res.data.ruleDTOList;
        this.ruleDTOList.forEach((item) => (item.minNum = item.totalAmount));

        if (this.isStartEdit) {
          //进行中活动 无法修改活动开启时间
          this.isStartEditTime = String(res.data.startTime);
        }
      });
    },

    // 活动进行中修改奖品数量
    beAdd() {
      console.log("this.goodItem.minNum", this.goodItem);
      if (this.isStartEdit) {
        if (
          this.goodItem.minNum &&
          Number(this.goodItem.totalAmount) < Number(this.goodItem.minNum)
        ) {
          this.goodItem.totalAmount = this.goodItem.minNum;
          this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
        }
      }
    },

    //生成规则
    generateRule() {
      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];
      //活动规则判断
      let text1 = "",
        text2 =
          "  （1）活动过程中，凡以不正当手段（如作弊领取、恶意套取、刷信誉、虚假交易、扰乱系统、实施网络攻击等）参与本次活动的用户，商家有权终止其参与活动，并取消其参与资格（如优惠已发放，商家有权追回），如给商家造成损失的，商家将保留向违规用户继续追索的权利；",
        text3 =
          "  （2）如遇不可抗力(包括但不限于重大灾害事件、活动受政府机关指令需要停止举办或调整的、活动中存在大面积作弊行为、活动遭受严重网络攻击或因系统故障导致活动中奖名单大批量出错，活动不能正常进行的)，商家有权取消、修改或暂停本活动。";

      //活动时间
      // if (this.ruleForm.activityStartTime && this.ruleForm.activityEndTime) {
      //     text1 =
      //         "1、活动时间：" +
      //         this.ruleForm.activityStartTime +
      //         "~" +
      //         this.ruleForm.activityEndTime +
      //         ";";
      // }
      //参与对象
      let text4 = "";
      if (
        this.ruleForm.activityObject == "1" &&
        this.ruleForm.partner1.length > 0
      ) {
        let levelText = [];
        this.ruleForm.partner1.forEach((item) => {
          if (item == -1) {
            item = "全部";
          } else if (item == 0) {
            item = "非会员";
          } else {
            this.levelList.forEach((it, index) => {
              if (index + 1 == item) {
                item = it;
              }
            });
          }
          levelText.push(item);
        });

        text4 = "活动参与对象：" + levelText.splice(",");
      } else {
        text4 = "活动参与对象：全部";
      }
      let text34 = ""
      if (this.ruleForm.activityObject == "1" && this.ruleForm.membershipTime && this.ruleForm.partner1!=[0]){
        text34 = `入会时间：${this.ruleForm.membershipTime}之后入会的会员可参与活动`
      }
      let Arr1 = [];
      Arr1 = [text1, text4,text34, text2, text3];
      let newText = "";
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + item + "\n";
        }
      });
      this.ruleForm.ruleDescription = newText;
    },

    // 上传图片
    beforeUpload1(file) {
      let _this = this;
      const isJPG = file.type === "image/jpg";
      const isJPEG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size < 2097152;
      if (!(isJPG || isPNG || isJPEG)) {
        this.$message.error("上传图片只能是JPG和PNG格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return false;
      }
      let forms = new FormData();
      forms.append("file", file);
      uploadImage(forms).then((res) => {
        this.imgUrlOne = res.data;
        if (this.step === 0) {
          this.imageUrl1 = res.data;
        } else if (this.step === 1) {
          this.imageUrl2 = res.data;
        }
        console.log(res, 1);
      });
      return !(isJPG || isPNG || isJPEG) && isLt2M;
    },

    //确定传参
    handleDialogCloseAnoth() {
      if (this.picType1 == 0) {
        this.imageUrl1 = "";
        this.imageUrl2 = "";
      }
      if (this.ruleDTOList.length == 0) {
        this.$message.warning("请选择商品");
        return;
      }
      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];
      let params = {
        activityName: this.ruleForm.activityName,
        startTime: this.ruleForm.activityStartTime,
        endTime: this.ruleForm.activityEndTime,
        activityObject: this.ruleForm.activityObject,
        membershipTime:this.ruleForm.membershipTime,
        newOldCustomer: this.ruleForm.newOldCustomer,
        buttonPicUrl:this.ruleForm.buttonPicUrl,
        buttonRgb:this.ruleForm.buttonRgb,
        seniorGroupId: this.peopleList.join(","),
        allowLevel: this.ruleForm.partner1.join(","), //参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
        picType: this.picType1,
        picUrl: this.imageUrl1
          ? this.imageUrl1
          : this.imageUrl2
          ? this.imageUrl2
          : "",
        ruleDescription: this.ruleForm.ruleDescription,
        ruleDTOList: this.ruleDTOList,
        subType: 33,
      };
      if (params.activityName == "") {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (params.ruleDescription == "") {
        this.$message.warning("请输入规则");
        return;
      }
      if (params.startTime == "" || params.endTime == "") {
        this.$message.warning("请输入时间");
        return;
      }
      if (this.$route.query.valueRow) {
        params.id = this.valueRow.id;
      }
      if (this.checked == true) {
        pointExchangeSave(params).then((res) => {
          if (res.code == 1) {
            this.$router.push({ path: "activeList1" });
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },

    //选择奖品
    centerVis(scope) {
      this.showDialog = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
        this.$refs.selectProduct.physicalGift(this.goodItem)
      });
    },

    //添加任务
    addTask() {
      if (this.ruleDTOList.length >= 10) {
        this.$message.warning("最多支持添加10个兑换商品");
        return;
      }
      this.nameTitle = "添加商品";
      this.goodItem = {
        consumePoint: "",
        title: "",
        exchangeLimit: "",
        logo: "",
        price: "",
        totalAmount: "",
        type: "",
        prizeId: "",
        prizeType: "",
      };
      this.ruleForm.joinType = [];
      this.dialogFormVisible = true;
      this.disItem = 2;
    },

    colseDialog() {
      this.showDialog = false;
    },

    //添加商品确定
    handleSave() {
      // 空数据判断
      if (this.goodItem.title == "") {
        this.$message.warning("请填写商品名称");
        return;
      }
      if (this.goodItem.logo == "") {
        this.$message.warning("请选择商品图片");
        return;
      }
      if (!this.goodItem.price) {
        this.$message.warning("请填写商品价格");
        return;
      }
      if (this.ruleForm.joinType.length == 0) {
        this.goodItem.joinType = "";
        // this.$message.warning("请选择参与要求")
        // return
      } else {
        if (this.ruleForm.joinType.includes("-1")) {
          this.goodItem.joinType = "";
        } else {
          if (this.ruleForm.joinType.length == 2) {
            this.goodItem.joinType = "1,2";
          } else {
            this.goodItem.joinType = this.ruleForm.joinType.includes("限粉丝")
              ? "2"
              : "1";
          }
        }
      }
      if (this.goodItem.consumePoint == "") {
        this.$message.warning("请填写消耗积分");
        return;
      }
      if (this.goodItem.totalAmount == "") {
        this.$message.warning("请填写商品份数");
        return;
      }
      if (this.goodItem.exchangeLimit == "") {
        this.$message.warning("请填写兑换上限");
        return;
      }

      if (this.nameTitle == "添加商品") {
        this.ruleDTOList.push(this.goodItem);
      } else {
        //编辑更新
        this.ruleDTOList[this.indexNum] = {
          joinType: this.goodItem.joinType,
          consumePoint: this.goodItem.consumePoint,
          exchangeLimit: this.goodItem.exchangeLimit,
          title: this.goodItem.title,
          price: this.goodItem.price,
          logo: this.goodItem.logo,
          totalAmount: this.goodItem.totalAmount,
          prizeId: this.goodItem.prizeId,
          type: this.goodItem.type,
          prizeType: this.goodItem.prizeType,
          minNum: this.goodItem.minNum,
          startDate: this.goodItem.couponType == 3 ? this.goodItem.startDate : undefined,
          endDate: this.goodItem.couponType == 3 ? this.goodItem.endDate : undefined,
          conditions: this.goodItem.couponType == 3 ? this.goodItem.conditions : undefined,
          remainPrizeQuantity: this.goodItem.couponType == 3 ?  this.goodItem.remainPrizeQuantity : undefined
        };
      }
      this.dialogFormVisible = false;
    },

    //上移
    moveUP(item, index) {
      if (this.ruleDTOList.length > 1 && index != 0) {
        var temp = this.ruleDTOList[index - 1];
        this.$set(this.ruleDTOList, index - 1, this.ruleDTOList[index]);
        this.$set(this.ruleDTOList, index, temp);
      }
    },

    //下移
    moveDown(item, index) {
      if (this.ruleDTOList.length > 1 && index != this.ruleDTOList.length - 1) {
        var temp = this.ruleDTOList[index + 1];
        this.$set(this.ruleDTOList, index + 1, this.ruleDTOList[index]);
        this.$set(this.ruleDTOList, index, temp);
      }
    },

    //删除
    deletePacket(params) {
      this.ruleDTOList.splice(params, 1);
    },

    //编辑
    edit(e, index) {
      if (e.joinType == "") {
        this.ruleForm.joinType = [];
        this.disItem = 2;
      } else if (e.joinType.includes(1) && e.joinType.includes(2)) {
        this.ruleForm.joinType = ["限会员", "限粉丝"];
        this.disItem = 1;
      } else if (e.joinType.includes(1)) {
        this.ruleForm.joinType = ["限会员"];
        this.disItem = 1;
      } else if (e.joinType.includes(2)) {
        this.ruleForm.joinType = ["限粉丝"];
        this.disItem = 1;
      }
      this.indexNum = index;
      this.nameTitle = "编辑兑换商品";
      console.log(e, 111);
      this.goodItem = JSON.parse(JSON.stringify(e));
      this.dialogFormVisible = true;
    },

    //清空商品数据
    deleteCoupon() {
      this.goodItem.price = null;
      this.goodItem.title = "";
      this.goodItem.prizeType = null;
    },

    //选择商品数据
    getTheData(data, prizeType) {
      console.log(data, prizeType, "data");
      this.colseDialog();
      const arr = this.ruleDTOList.filter((item) => {
        if (prizeType == 3) {
          return item.prizeId == data.couponId && data.couponId;
        } else if (prizeType == 1) {
          if(data.couponType==3) {
            return item.assetsId == data.couponId && data.couponId;
          } else {
            return item.batchKey == data.batchKey && data.batchKey;
          }
        } else {
          return item.prizeId == data.id;
        }
      });
      if (arr.length != 0) {
        this.$message.warning("请勿重复选择同一个商品");
        return;
      }
      this.goodItem.prizeType = prizeType;
      if (prizeType == 3) {
        // 实物
        this.goodItem.logo = data.logo;
        this.goodItem.title = data.name;
        this.goodItem.price = data.discount;
        this.goodItem.prizeId = data.couponId; // 普通实物传skuId，专属下单实物传id
        this.goodItem.type = data.couponId ? 2 : 1; // 实物类型：1普通上传图片实物 2普通实物 3专属下单实物 4优惠券
      }  else if(prizeType == 1){
          this.goodItem.prizeType = prizeType;
          this.goodItem.price = data.price;
          this.goodItem.logo = "https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/yunqihd_B/coupon_new.png";
          this.goodItem.prizeId = -1;
          this.goodItem.couponType = data.couponType;
          this.goodItem.type = 4;
        if(data.couponType==4) {
          this.goodItem.assetsId = null;
          this.goodItem.singleAmount = 1;
          this.goodItem.title = "优惠券";
          this.goodItem.batchKey = data.batchKey;
        } else {
          this.goodItem.title = data.name || prizeType;
          this.goodItem.price = data.discount || data.singleAmount;
          this.goodItem.singleAmount = data.singleAmount;
          this.goodItem.assetsId = Number(data.couponId);
          this.goodItem.startDate = data.startDate;
          this.goodItem.endDate = data.endDate;
          this.goodItem.conditions = data.conditions ? data.conditions : "";
          this.goodItem.remainPrizeQuantity = data.remainPrizeQuantity
        }
      } else {
        // 专属下单
        this.goodItem.logo = data.picUrl;
        this.goodItem.title = data.itemTitle;
        this.goodItem.price = data.price;
        this.goodItem.exchangeLimit = 1; // 专属下单默认为1，不可修改
        this.goodItem.prizeId = data.id; // 普通实物传skuId，专属下单实物传id
        this.goodItem.type = 3; // 实物类型：1普通上传图片实物 2普通实物 3专属下单实物  4优惠券
      }
      this.showDialog = false;
    },

    //活动时间驱动
    activityTimeChange(val) {
      if (this.isStartEdit) {
        //进行中活动 无法修改活动开启时间
        this.activityTimeValue[0] = this.isStartEditTime;
      }
      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.activityStartTime).valueOf();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      let invalidateDate = new Date(
        this.$store.state.loginUserInfo.expiredIn
      ).valueOf();
      if (this.backgroundOpacity) {
        var datas, change1, change2, days, daysStart, daysEnd, date3;
        daysStart = this.ruleForm.activityStartTime.substring(0, 10);
        daysEnd = this.ruleForm.activityEndTime.substring(0, 10);
        if (
          this.ruleForm.activityEndTime != "" &&
          this.ruleForm.activityStartTime != ""
        ) {
          datas = daysEnd.split("-");
          change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
          datas = daysStart.split("-");
          change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
          days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
          this.timeDay = days;
          //计算小时
          date3 =
            new Date(this.ruleForm.activityEndTime).getTime() -
            new Date(this.ruleForm.activityStartTime).getTime();
          var leave1 = date3 % (24 * 3600 * 1000);
          this.timeOut = Math.floor(leave1 / (3600 * 1000));
        } else {
          this.timeOut = 0;
          return;
        }
        return;
      }
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = null;
        return;
      }
      if (start < nowTime) {
        if (this.activeValue) {
          this.disableTime = true;
        } else {
          if (!this.isStartEdit) {
            this.$message.warning("开始时间不能小于当前时间");
          }
        }
      }
      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
      }
      if (end < start) {
        this.$message.warning("结束时间不能小于开始时间");
        return;
      }
      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart = this.ruleForm.activityStartTime.substring(0, 10);
      daysEnd = this.ruleForm.activityEndTime.substring(0, 10);
      if (
        this.ruleForm.activityEndTime != "" &&
        this.ruleForm.activityStartTime != ""
      ) {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        this.timeDay = days;
        //计算小时
        date3 =
          new Date(this.ruleForm.activityEndTime).getTime() -
          new Date(this.ruleForm.activityStartTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
        return;
      }
      if (
        this.ruleForm.activityEndTime &&
        this.ruleForm.activityStartTime &&
        this.ruleForm.activityEndTime.substring(0, 10) ==
          this.ruleForm.activityStartTime.substring(0, 10)
      ) {
        this.$message.warning("活动时间不能小于一天");
        this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = "";
      }
    },
    // 返回上一步
    returnBack() {
      this.$emit("returnBack");
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    //保存编辑
    saveEdit() {
      this.joinBlackList = true;
    },

    // 添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;

      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
    },
    selectGoodsSure(data) {
      if (!data) {
        this.selectGoodsState = false;
        return;
      }
    },
    selectGoodsClose(event, index) {
      if (typeof event != "boolean") {
        let newArr = event;
        if (index && index == 1) {
          this.itemListFor = newArr;
          this.mainImagelist = newArr;
          this.selectGoodsArr = newArr;
        }
      }

      this.selectGoodsState = false;
    },

    // 返回上一步
    clickLocalStep() {
      sessionStorage.setItem("goBack", this.activityData.goIndex);
      if (this.$route.query.copyParams && this.$route.query.copyParams.isCopy) {
        sessionStorage.setItem("goBackCopy", true);
      }
      this.$router.go(-1);
    },
    checkputnCount(e, row) {
      if (row.quantityTotal && row.price && row.prizeCount) {
        let numTotal = this.$jingdouTotal(row);
        if (!numTotal) {
          this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
        }
        return numTotal;
      } else {
        return row.prizeCount;
      }
    },
    // 品牌定制弹窗
    handleOpen() {
      const href =
        "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch(() => {});
    },
     //选中改变
    checkListchange(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner1 = ["-1"];
        }
      });
    },
    handleActivityObj() {
      this.ruleForm.newOldCustomer = 0;
      this.ruleForm.partner1 = ["-1"];
      this.peopleList = [];
    },
    picUrlHandleChange(file){
      const isLt3M = file.size < 1024 * 300;
      let typeArr = file.name.split('.')
      if(typeArr[typeArr.length-1]!='jpg'&&typeArr[typeArr.length-1]!='png'&&typeArr[typeArr.length-1]!='jpeg'){
        this.$message.error("只能上传jpg、png格式图片");
        return false
      }
      if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 300K");
        return false
      } else {
        console.log(this.$refs.uploadRef,'1111166666');
        let formdata = new FormData();
        formdata.append("file", file);
        uploadImage(formdata).then((res) => {
          this.ruleForm.buttonPicUrl = res.data;
          // 获取图片真实url
          // row.logo = res.data;
        });
      }
    },
    handleChange(file,row) {
      const isLt3M = file.size < 1024 * 300;
      let typeArr = file.name.split('.')
      if(typeArr[typeArr.length-1]!='jpg'&&typeArr[typeArr.length-1]!='png'&&typeArr[typeArr.length-1]!='jpeg'){
        this.$message.error("只能上传jpg、png格式图片");
        return false
      }
      if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 300K");
        return false
      } else {
        console.log(this.$refs.uploadRef,'1111166666');
        let formdata = new FormData();
        formdata.append("file", file);
        uploadImage(formdata).then((res) => {
          // 获取图片真实url
          row.logo = res.data;
        });
      }
    },
    handleDelete(row) {
      row.logo = ""
    }
  },
};
</script>

<style lang="scss" scoped>
.buttonBox{
  padding: 20px 0;
  width: 850px;
  background: #f8f9ff;
  border-radius: 8px 8px 8px 8px;
}
.date_icon3 {
  width: 80px;
  height: 80px;
  vertical-align: middle;
  border-radius: 4px 4px 4px 4px;
}
.coupon_icon {
  width: 230px;
  vertical-align: middle;
  border-radius: 4px 4px 4px 4px;
}

.theLag {
  position: relative;
  margin-top: 10px;
  height: 142px;
  width: 302px;

  .theBox {
    height: 142px;
    width: 302px;
    // border: 1px solid #999;
    background: url("../../assets/thdImg/pages/yhq.svg") no-repeat;
    border-radius: 8px;
    position: absolute;
    color: #333333;

    .price_sty {
      font-family: DIN;
      font-weight: bold;
      color: #2670fb;
      font-size: 45px;
    }

    .pp {
      width: 280px;
      text-align: center;
      bottom: 0px;
    }
  }

  .btnQx {
    display: none;
  }

  &:hover {
    .btnQx {
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      margin: -16px 0 0 -49px;
    }

    .backgrd {
      width: 302px;
      height: 142px;
      background: #fff;
      position: absolute;
      border-radius: 8px;
      opacity: 0.7;
    }
  }
}

.wide {
  width: 850px;
  background: #f8f9ff;
  border-radius: 8px 8px 8px 8px;
  opacity: 1;
  margin-bottom: 10px;
  padding: 20px;
  position: relative;
  line-height: 21px;
  color: #666666;

  .posi {
    position: absolute;
    right: 24px;
    top: 22px;
  }
}

.imgUpload {
  display: flex;
  align-items: center;
}

/deep/.stepBox .el-step.is-horizontal .el-step__line {
  left: 155px;
}

/deep/.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

/deep/.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 130px;
  height: 230px;
  line-height: 230px;
  text-align: center;
}

/deep/.avatar {
  width: 130px;
  height: 230px;
  display: block;
}

/deep/ .el-table__row:hover {
  .delQx {
    display: flex;
  }
}

.startTime {
  /deep/ .el-table__body-wrapper {
    padding-left: 30px !important;
  }
}

.prosi {
  position: absolute;
  bottom: 45px;
  right: 20px;
}

.delectPosible:hover {
  -webkit-box-shadow: #ccc 0px 1px 1px;
  -moz-box-shadow: #ccc 0px 1px 1px;
  box-shadow: #ccc 0px 1px 1px;
}

.flex {
  display: flex;
  align-items: center;
}

.coupon_icon,.date_icon3 {
  position: relative;
  .logo-modal {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba($color: #000, $alpha: 0.3);
    .delete-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      color: #fff;
      cursor: pointer;
    }
  }
  &:hover .logo-modal{
    display: block;
  }
}

.del_box {
  position: absolute;
  left: 145px;
  top: 15px;
  width: 50px;
  height: 50px;
}

.delQx {
  width: 25px;
  height: 25px;
  background: rgb(255, 76, 68);
  display: inline-block;
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  img {
    width: 50px;
    margin-right: 4px;
  }

  // display: none;
}

.prize_box {
  padding: 26px 21px;
  background: #fcfcfc;

  .tips {
    width: 600px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    background: #fffaee;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    margin-bottom: 9px;
  }

  .add_btn {
    cursor: pointer;
    color: #7f85e9;
    border: 1px dashed #7f85e9;
    width: 625px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
  }
}

.line {
  display: flex;
  align-items: center;
}

.createPlayStep {
  min-width: 1360px;
  position: relative;
  box-sizing: border-box;
  min-height: 80vh;
  height: 88.5vh;
  background-color: #fff;
  border-radius: 6px;
  margin: 24px;

  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;

    span {
      color: #ccc;
      cursor: pointer;
    }

    .name {
      color: #333;
      cursor: default;
    }
  }

  .step {
    padding: 30px 24px 0;

    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      margin-left: 11%;
    }
  }

  .firststep {
    min-height: 820px;
    box-sizing: border-box;
    padding: 35px 35px 0;

    .itemList {
      display: flex;

      .item {
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;

        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }

        .border {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;

          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }

          &::before {
            border-top: 1px solid #fe4d45;
            border-bottom: 1px solid #fe4d45;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }

          &::after {
            border-right: 1px solid #fe4d45;
            border-left: 1px solid #fe4d45;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }

        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;

          .queryId {
            display: none;
          }

          &:hover {
            .queryId {
              display: block;
            }

            .mask {
              opacity: 1;
            }
          }

          .mask {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;

            .img {
              max-width: 130px;
              margin: 0 auto 30px;

              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }

              .tpl {
                display: inline-block;
                margin-top: 10px;
                color: #fff;
                // opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }

  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;

    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }

    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(38, 112, 251, 0.1);
      border: 1px solid #2670fb;
      color: #2670fb;
      border-radius: 4px;
    }

    .lastTime {
      margin-left: 20px;
      font-size: 14px;

      i {
        color: #ccc;
      }
    }

    .theLag {
      position: relative;
      margin-top: 10px;
      height: 142px;
      width: 302px;

      .theBox {
        height: 142px;
        width: 302px;
        background: url("../../assets/thdImg/pages/yhq.svg") no-repeat;
        border-radius: 8px;
        position: absolute;
        color: #333333;

        .price_sty {
          font-family: DIN;
          font-weight: bold;
          color: #2670fb;
          font-size: 45px;
        }

        .pp {
          width: 280px;
          text-align: center;
          bottom: 0px;
        }
      }

      .btnQx {
        display: none;
      }

      &:hover {
        .btnQx {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          margin: -16px 0 0 -49px;
        }

        .backgrd {
          width: 302px;
          height: 142px;
          background: #fff;
          position: absolute;
          border-radius: 8px;
          opacity: 0.7;
        }
      }
    }

    .productImg {
      margin-top: 10px;
      background-color: #fafafa;
      min-height: 80px;
      width: 800px;
      border-radius: 5px;
    }

    .desc {
      i {
        opacity: 0.7;
        color: #fe4d45;
      }

      color: #999;
    }

    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(254, 77, 69, 1);
      color: #fe4d45;
      transition: all 0.2s;

      &:hover {
        background-color: #fe4d45;
        color: #fff;
      }
    }

    .keepBtn {
      margin-left: 30px;
      width: 188px;
      background-color: #fe4d45;
      color: #fff;
      transition: all 0.2s;

      &:hover {
        opacity: 0.9;
      }
    }
  }
}

.wrapper-kaika {
  width: 100%;
  height: 100%;
  display: grid;

  &-img {
    background-color: #fafafa;
    border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
    border-radius: 8px;
    height: 350px;
    position: relative;

    &:hover {
      .borderkaika::before,
      .borderkaika::after {
        opacity: 1;
        transform: scale(1);
      }
    }

    .borderkaika {
      position: absolute;
      left: -6px;
      top: -6px;
      width: 218px;
      height: 360px;
      border-radius: 4px;

      &::before,
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        content: "";
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.8s, transform 0.8s;
        border-radius: 4px;
      }

      &::before {
        border-top: 1px solid #fe4d45;
        border-bottom: 1px solid #fe4d45;
        -webkit-transform: scale(0, 1);
        transform: scale(0, 1);
      }

      &::after {
        border-right: 1px solid #fe4d45;
        border-left: 1px solid #fe4d45;
        -webkit-transform: scale(1, 0);
        transform: scale(1, 0);
      }
    }

    div {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
    }

    img {
      width: 32px;
      height: 32px;
    }

    .queryIdIMG {
      display: none;
    }

    &:hover {
      .queryIdIMG {
        display: block;
      }

      .mask {
        opacity: 1;
      }
    }

    .mask {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
      opacity: 0;
      transition: all 0.2s;

      .img {
        max-width: 130px;
        margin: 0 auto 30px;

        .imgBg {
          box-sizing: border-box;
          height: 129px;
          width: 129px;
          padding: 6px;
          border-radius: 6px;
          background-color: #fff;
        }

        .tpl {
          display: inline-block;
          font-size: 14px;
          color: #fff;
          margin-top: 10px;
        }
      }
    }
  }

  &-tanchuang {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .lijijq {
    &::after {
      content: "立即领取";
      display: block;
      position: absolute;
      bottom: 9px;
      left: 51%;
      transform: translateX(-50%);
      font-size: 14px;
      font-family: system-ui;
      font-weight: bold;
      color: #ed6e09;
      text-shadow: 0 0 black;
    }
  }
}

.rulebox {
  width: 750px;
  min-height: 300px;
  background: #f8f9ff;
  border-radius: 8px;
  margin-top: 10px;
  padding: 24px;
  line-height: 30px;

  &_flex {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    &_left {
      width: 100px;
    }

    &_btn {
      padding: 0px 10px;
      height: 32px;
      color: #2670fb;
      line-height: 32px;
      background: rgba(38, 112, 251, 0.1);
      border-radius: 4px;
      border: 1px solid #2670fb;
    }
  }

  .createAdd_save {
    margin-top: 24px;
    width: 100px;
    height: 32px;
    background: #2670fb;
    margin-right: 20px;
    border-radius: 4px;
    color: #fff;
    line-height: 32px;
    text-align: center;

    &:hover {
      opacity: 0.8;
    }
  }

  .createAdd_qx {
    margin-top: 24px;
    width: 100px;
    height: 32px;
    background: #fff;
    margin-right: 20px;
    border-radius: 4px;
    color: #606266;
    line-height: 32px;
    text-align: center;
    border: 1px solid #dddddd;

    &:hover {
      color: #fff;
      background: #2670fb;
      border: 1px solid #2670fb;
    }
  }
}
.coupon-box {
  // padding-left: 75px;
  display: flex;
  .flex-box {
    display: flex;
    flex-direction: column;
  }
  .label-width {
    width: 90px;
    text-align: right;
  }
  .num-style {
    width: 75px;
  }
}
.flexc-cen-start {
  display: flex;
  align-items: start;
}
.logo-style {
  width: 100%;
  height: 100%;
}
/deep/.el-upload--picture-card {
  width: 80px;
  height: 80px;
  line-height: 87px;
  // 隐藏上传进度过渡盒子
  .el-upload-list__item {
    transition: none !important;
  }
}
</style>
